var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center mt-6 mt-md-10 white--text px-5 px-sm-1"},[_c('div',{staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(_vm.staticTranslation('texts.terms'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }